<template>
    <div class="search-box">
        <input type="text" autocomplete="off"  name="" :id="id" ref="inputBox" class="input-box" @blur="cancle" @keydown.enter="getComposite(keyWord)" v-model="keyWord" @focus="reqLenovoWord" @keyup="reqLenovoWord">
        <button class="search-btn" @click="getComposite(keyWord)">搜索</button>
          <el-collapse-transition>
            <div class="Lenovo-word" v-if="isShow">
                <p class="p-top">↓点击直达车系频道</p>
                <ul>
                    <li v-for="(lenovo,index) in lenovoLists" :key="index" @click="lenovoSearch(lenovo)"><span class="cars-name">{{lenovo.keyword}}</span><span class="cars-price">{{lenovo.price}}</span></li>
                </ul>
                <p class="p-bottom" @click="isShow=false;countAd(4517)">关闭</p>
            </div>
          </el-collapse-transition>
    </div>
</template>

<script>
    export default {
        name: 'SearchBox',
        props: { 
            id: { //为了解决浏览器info提示input元素不唯一
                type:Number,
                default:0
            }
        },
        data() {
            return {
                keyWord: '', // 搜索关键词
                isShow: false, //是否显示联想词
                lenovoLists: [], //联想词
            }
        },
        methods: {
            cancle() { //失去焦点时取消联想词
                setTimeout(()=>{
                    this.isShow =false
                },101)
            },
            //请求联想词数据
            async reqLenovoWord() {
                try {
                    if(this.keyWord) {
                        const res = await this.fetCompletion({q:this.keyWord})
                        if(res.length > 0) {
                            this.isShow = true
                        }else {
                            this.isShow = false
                        }
                        this.lenovoLists = res
                    }else {
                        this.isShow = false
                    }
                } catch (error) {
                    console.error(error)
                }
            },
            //搜索输入的关键词
            async getComposite(word) {
                if(word) {
                    let inputBox = this.$refs.inputBox
                    if(inputBox) { //搜索是取消foucs
                        inputBox.blur()
                    }
                    this.$global.q = word
                    // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${word}&${this.$global.tab.title}=true`)
                    window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${this.$global.tab.title}&q=${word}`)
                    // this.$EventBus.$emit(`${this.$global.tab.title}`)
                }else {
                    this.$EventBus.$emit('closeContent')
                }
            },
            //联想词搜索
            lenovoSearch(item) {
                this.countAd(4516)
                let inputBox = this.$refs.inputBox
                if(inputBox) {
                    inputBox.blur()
                    this.isShow = false
                }
                if(item.isSerialGroup) {
                    window.open(`https://price.pcauto.com.cn/sg${item.sid}/#ad=5439`)
                }else if(item.isFactory) {
                    // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${item.keyword}&${this.$global.tab.title}=true`)
                    window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${this.$global.tab.title}&q=${item.keyword}`)
                }else if(item.isBrand) {
                    // window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?q=${item.keyword}&${this.$global.tab.title}=true`)
                    window.location.href = window.encodeURI(`${window.location.origin}${window.location.pathname}?tab=${this.$global.tab.title}&q=${item.keyword}`)
                }
            }
        },
        mounted() {
            this.$EventBus.$on('searchFromRecommend',(word) => {
                this.keyWord = word
                this.getComposite(word)
            })
            this.keyWord = this.$global.q
        },
        beforeDestroy() {
            this.$EventBus.$off('searchFromRecommend')
        }
    }
</script>

<style lang="scss" scoped>
.search-box {
    display: flex;
    width: 620px;
    position: relative;
    height: 30px;
    margin-top: 6px;
    margin-bottom: 10px;
    z-index: 99;
    .input-box {
        flex: 1;
        padding-left: 5px;
        box-shadow: #afafaf 1px 1px 1px inset;
        border: 1px #e0e0e0 solid;
        line-height: 27px;
        font-size: 16px;
        box-sizing: border-box;
        &:focus {
            border: 1px solid #000000;
        }
    }
    .search-btn {
        width: 75px;
        height: 100%;
        font-size: 16px;
        color: #ffffff;
        background-color: #ff9900;
        cursor: pointer;
    }
    .Lenovo-word {
        position: absolute;
        width: calc(100% - 75px);
        top: 30px;
        background-color: #ffffff;
        z-index: 88;
        font-size: 14px;
        border: 1px solid #777777;
        box-sizing: border-box;
        .p-top {
            color: #225599;
            padding: 0 5px;
            border-bottom: 1px dashed #777777;
            font-family: "";
            font-size: 12px;
            height: 24px;
            line-height: 24px;
        }
        .p-bottom {
            line-height: 25px;
            font-size: 14px;
            background-color: #f5f5f5;
            text-align: right;
            padding-right: 5px;
            cursor: pointer;
        }
        ul {
            .cars-name {
                color: #777777;
            }
            .cars-price {
                color: #cc0000;
            }
            li {
                line-height: 24px;
                padding: 0 5px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                &:hover {
                    background-color: #ffedca;
                }
            }
        }
    }
}
</style>